<h1 mat-dialog-title>
	<span i18n>New app key</span>
	<button type="button" mat-icon-button [matMenuTriggerFor]="appKeyMenu" class="app-key-menu-btn">
		<span class="material-icons">more_vert</span>
	</button>
	<mat-menu #appKeyMenu="matMenu" xPosition="before">
		<div class="top-right-drop-menu">
			<button mat-menu-item (click)="viewDocumentation()">
				<div class="row px-2">
					<div class="col pl-2"><span>Documentation</span></div>
				</div>
			</button>
		</div>
	</mat-menu>
</h1>

<div mat-dialog-content>
	<mat-vertical-stepper [selectedIndex]="selectedStepIndex" [linear]="true" #stepper>
		<mat-step [completed]="appKey" [editable]="false">
			<form [formGroup]="createForm">
				<ng-template matStepLabel i18n>Create</ng-template>

				<div class="col-12 alert alert-info alert-panel-text" i18n>
					App keys enables access to the Zone 5 Cloud API. To begin:
					<ul>
						<li>Chose a cluster</li>
						<li>Name your application</li>
					</ul>
				</div>

				<div class="row align-items-center">
					<div class="col col-sm-5">
						<app-search-select
							[data]="providers"
							[selected]="provider"
							(selectedChange)="providerSelected($event)"
							title="Provider"
							i18n-title
						></app-search-select>
					</div>
					<div class="col">
						<mat-form-field appearance="standard" class="w-100" floatLabel="always">
							<mat-label i18n>Name</mat-label>
							<input matInput type="text" placeholder="My app" i18n-placeholder formControlName="name" />
							<mat-error
								appFormErrorMessage
								[errorFormControl]="createForm.controls.name"
								[type]="formEditorInputType.text"
							></mat-error>
						</mat-form-field>
					</div>
				</div>
					<div class="row justify-content-end mt-3">
						<mat-form-field appearance="standard" class="w-100" floatLabel="always" [hidden]="provider != 'Entra'">
                            <mat-label i18n>Entra ClientId</mat-label>
                            <input matInput type="text" placeholder="<entra clientId>" i18n-placeholder formControlName="clientId" />
                            <mat-error
                                appFormErrorMessage
                                [errorFormControl]="createForm.controls.clientId"
                                [type]="formEditorInputType.text"
                            ></mat-error>
                        </mat-form-field>
					</div>

				<div class="row justify-content-end mt-3">
					<div class="col">
						<button class="w-100" type="submit" (click)="createAppKey()" mat-flat-button color="primary" [disabled]="!provider" i18n>Create</button>
					</div>
				</div>
			</form>
		</mat-step>

		<mat-step [optional]="true">
			<ng-template matStepLabel i18n>Settings</ng-template>
			<app-appkey-edit-form
				*ngIf="appKey && cluster && stepper.selectedIndex === 1"
				[(appKey)]="appKey"
				[company]="dialogData.company"
				[cluster]="cluster"
				[enableName]="false"
				[enableSuspend]="false"
				[(unsavedChanges)]="unsavedChanges['1']"
				(closed)="selectStep(2)"
				(cancelled)="resetStep(1)"
				(updated)="selectStep(2)"
				[confirmUpdate]="false"
				[closeLabel]="i18nService.get('Next', 'app.descriptor.next')"
				[cancelLabel]="i18nService.get('Reset', 'app.descriptor.reset')"
			></app-appkey-edit-form>
		</mat-step>

		<mat-step [optional]="true">
			<ng-template matStepLabel i18n>Legals</ng-template>
			<app-appkey-legals-table
				*ngIf="appKey && appKeyLegals && stepper.selectedIndex === 2"
				[company]="dialogData.company"
				[appKey]="appKey"
				[terms]="appKeyLegals"
				class="mt-2 d-block"
			></app-appkey-legals-table>
		</mat-step>
	</mat-vertical-stepper>

	<div mat-dialog-actions class="row justify-content-center mb-0">
		<div class="col col-sm-6">
			<button class="w-100 app-key-new-close" mat-flat-button mat-dialog-close (click)="cancel()" i18n type="button">Close</button>
		</div>
	</div>
</div>
